import React, { useState, useEffect, useRef } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import styled from "styled-components/macro";

import IconButton from "../IconButton";

function useTemporaryState(initialState, delay) {
  const [value, setValue] = useState(initialState);
  const timeoutRef = useRef(null);

  function setValueWithTimer(newValue) {
    setValue(newValue);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setValue(initialState), delay);
  }

  useEffect(() => {
    return () => {
      setValue(initialState);
      clearTimeout(timeoutRef.current);
    };
  }, [setValue, initialState]);

  return [value, setValueWithTimer];
}

export function CopyableTextInput(props) {
  const inputRef = React.useRef(null);
  const [hasSavedText, setHasSavedText] = useTemporaryState("Copy", 2000);

  function handleCopy() {
    setHasSavedText("Copied!");
    inputRef.current?.select();
  }

  return (
    <Container>
      {/* <input
        ref={inputRef}
        readOnly
        onFocus={(event) => event.target?.select()}
        {...props}
      /> */}
      <CopyToClipboard
        text={props.value}
        onCopy={handleCopy}
      >
        <IconButton
          src={hasSavedText === "Copy" ? "/assets/duplicate.svg" : "/assets/check-simple.svg"}
          hoverTipText={hasSavedText}
        />
      </CopyToClipboard>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  font-size: 14px;

  input {
    flex: 1;
    border: none;
    font-family: "IBM Plex Mono", monospace;
    font-weight: 500;
    opacity: 0.5;
  }

  button {
    font-size: inherit;
    opacity: 0.5;
  }

  .hover-tip {
    width: 44px;
  }
`;
